import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

export const useCompanyPageSettings = () => {
  const { company } = useCurrentSession()

  const buildUrl = (path: string): string => {
    if (!company.publicUrl) {
      return ''
    }

    try {
      const url = new URL(path, company.publicUrl)
      return url.toString()
    } catch (error) {
      return ''
    }
  }

  return {
    publicUrl: company.publicUrl,
    buildUrl,
  }
}
